module.exports = __webpack_public_path__ + "static/img/logo_w-m.49ce520.svg";